import React, { useContext } from 'react'
import styled from 'styled-components'
import PageLayout from '../../components/PageLayout'
import { RecordContext } from './RecordPage'
import { AppContext } from '../../Context'
import RecordAttachmentUploader from '../../components/RecordAttachmentUploader'
import { get } from 'lodash'
import Stepper from '../../components/Stepper'
import { getAttachByCategory } from '../../utils'

const RecordAttachmentContainer = styled(PageLayout)`
  .field {
    margin-bottom: 26px;
  }  
`

function RecordAttachment({ ...props }) {

  const { attachmentConfig, recordAttachConfig, employee } = useContext(AppContext)
  const { record, steps, setRecord, parentHistory } = useContext(RecordContext)

  const checkFilter = (filter, target) => {
    const ok = filter.reduce((previous, item) => {
      if(previous) {
        const toCheck = get(target, item.field)
        if(toCheck === null || toCheck === undefined) {
          return false
        }
        if (!item.op || item.op === 'eq') {
          return toCheck === item.value
        }
        switch (item.op) {
          case 'in':
            if(!Array.isArray(item.value)) {
              return false
            }
            return item.value.indexOf(toCheck) > -1
          case 'gte':
            return toCheck >= item.value
          case 'gt' :
            return toCheck > item.value
          default:
            return toCheck === item.value
        }
      }
      return false
    }, true)
    return ok
  }
  const showAttachment = (config) => {
    if(!config.filter) {
      return true
    }
    const checkEmployee = config.filter.employee ? checkFilter(config.filter.employee, employee) : true
    const checkRecord = config.filter.record ? checkFilter(config.filter.record, record) : true
    return checkEmployee && checkRecord
  }
  const checkCanSubmit = () => {
    if(!record || !recordAttachConfig) {
      return false
    }
    for(const config of recordAttachConfig) {
      if(!config.optional && showAttachment(config) && !getAttachByCategory(record, config.category)) {
        return false;
      }
    }
    return true
  }
  const canSubmit = checkCanSubmit()
  return (
    <RecordAttachmentContainer
      title="3 | Mes justificatifs"
      prevLink='/employee-contact'
      actions={ {
        submitTxt: 'Suivant',
        submitLink: '/signature',
        cancelTxt: 'Enregistrer et revenir plus tard',
        onCancel: () => parentHistory.push('/'),
        disableSubmit: !canSubmit
      } }
    >
      <Stepper steps={steps} activeStep={2}/>
      { (record && attachmentConfig && recordAttachConfig) &&
      recordAttachConfig.map((item, index) => {
        return showAttachment(item) && item.category !== 'babysitting_supp' ?
          <RecordAttachmentUploader
            key={index}
            description={<>{item.description && item.description+' '}<span>Taille maxi de { attachmentConfig.maxSize } Mo au format PNG, JPG ou PDF</span></>}
            attachConfig={ item }
            uploadConfig={ attachmentConfig }
            disabled={ get(record, 'disabled') }
            record={record}
            setRecord={setRecord}
          /> : null
      })
      }
    </RecordAttachmentContainer>
  )
}

export default RecordAttachment
